"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getWebGL_1 = require("./getWebGL");
exports.getWebGL = getWebGL_1.getWebGL;
